export default __webpack_public_path__ + "images/SpeakersPhotos/Noelia.jpg?75a962c0";